// make generated .d.ts file valid
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { DNode, WNodeFactory, WidgetProperties } from '@dojo/framework/core/interfaces';
// import { createICacheMiddleware } from '@dojo/framework/core/middleware/icache';
import { theme } from '@dojo/framework/core/middleware/theme';
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { ThemeProperties } from '@dojo/framework/core/middleware/theme';
import { create, w } from '@dojo/framework/core/vdom';
import { TopicDef } from '@holmescorp/lcc-state/interfaces';

import css from '../css/topicaccordion.m.css';

export interface TopicsetBodyProperties {
	kids: TopicDef[];
	key: string | number;
	isOpen: boolean;
}

const factory = create({ theme }).properties<TopicsetBodyProperties>();

export const TopicsetShortdesc = factory(({ properties, middleware: { theme } }) => {
	const { kids, isOpen } = properties();
	const themeCss = theme.classes(css);
	const additionalClasses = [themeCss.shortDesc, isOpen ? null : themeCss.truncate];
	const sd = kids.filter((val) => 'shortdesc' in val);
	const shortdesc = sd.length > 0 ? sd[0] : { shortdesc: '' };

	return w('shortdesc', { topicdata: shortdesc.shortdesc, additionalClasses });
});
